<template>
  <div class="main">
    <headpage></headpage>
    <div class="banner">
      <swipe :url="bannerUrl"></swipe>
    </div>
    <div class="menu">
      <van-grid>
        <van-grid-item>
          <router-link to="/class">
            <img src="../../icons/find.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">热门专业</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/school">
            <img src="../../icons/area.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">校园环境</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/place">
            <img src="../../icons/school.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">学校简介</div>
          </div>
        </van-grid-item>

        <van-grid-item>
          <router-link to="works">
            <img src="../../icons/students.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">教学作品</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/jobs">
            <img src="../../icons/work.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">推荐就业</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/shop">
            <img src="../../icons/teacher.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">我要开店</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/news">
            <img src="../../icons/news.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">学校新闻</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <router-link to="/contact">
            <img src="../../icons/lianxi.png" class="menu-img" alt />
          </router-link>
          <div
            style="
              width: 100%;
              height: 14px;
              text-align: center;
              line-height: 14px;
            "
          >
            <div class="menu-title">查看学费</div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div style="width100%;height:10px;background:#eee;"></div>
   

    <srcoll></srcoll>
    <!-- <count></count> -->
    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle title1="热门专业" title2="HOT MAJORS"></indexTitle>
    <tab></tab>
    <find goto="/class"></find>
    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle
      title1="选择绵阳欧米奇的理由"
      title2="REASONS FOR CHOOSING CHENGDU OMICK"
    ></indexTitle>
    <div class="class1">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/mianyang/home/class1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle
      title1="教学作品"
      title2="你们的成长，烙印在每一个作品中"
    ></indexTitle>
    <swipe3 :swipeUrls="worksUrl"></swipe3>
    <find goto="works"></find>

    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle
      title1="名师风采"
      title2="精英名师亲授，助力你的成功事业路"
    ></indexTitle>
    <swipe1 :swipeUrls="teacherUrls"></swipe1>
    <find goto="/teacher"></find>

    <div style="width100%;height:10px;background:#eee;margin-top:5px"></div>
    <indexTitle title1="校园风景" title2="欧式风格，环境超赞！"></indexTitle>
    <swipe2 :swipeUrls="schoolUrls"></swipe2>
    <find goto="/school"></find>

    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle
      title1="创就业帮扶"
      title2="全国30余家家院校联动，全方位创就业扶持"
    ></indexTitle>
    <tab2></tab2>
    <find goto="/jobs"></find>
    <div style="width100%;height:10px;background:#eee;margin-top:10px;"></div>
    <indexTitle title1="学生关注" title2="解决问题，没有顾虑"></indexTitle>
    <div class="students">
      <router-link to="chat">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/students.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/student2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/student3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </router-link>
    </div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <indexTitle
      title1="选择课程 了解学费"
      title2="Choose a course to learn about tuition"
    ></indexTitle>
    <footerForm
      color="#fff"
      bag="#a96b04"
      words="点击获取学费报价"
    ></footerForm>
    <foot></foot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOn: false,
      username: "",
      mobile: "",
      border: "",
      // bannerUrl2:[
      //    {
      //     img: 'https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/wapbanner/banner20200611.jpg',
      //     to: 'chat',
      //   },
      //    {
      //     img: 'https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/wapbanner/banner20200612.jpg',
      //     to: 'chat',
      //   },
      //    {
      //     img: 'https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/wapbanner/banner20200610.jpg',
      //     to: 'chat',
      //   },
      // ],
      bannerUrl: [
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/mianyang/banner/banner1.jpg",
          to: "chat",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/mianyang/banner/banner2.jpg",
          to: "chat",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/m_20210723_2.jpg",
          to: "class",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/m_20210723_4.jpg",
          to: "westfood9",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/m_20210723_6.jpg",
          to: "coffee",
        },
      ],

      teacherUrls: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/teacher1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/teacher2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/teacher3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/teacher4.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/teacher5.jpg",
      ],
      schoolUrls: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/school1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/school2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/school3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/school4.jpg",
      ],
      worksUrl: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/works1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/works2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/works3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/works4.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/works5.jpg",
      ],
    };
  },
  components: {
    swipe: () => import("@/components/common/swipe"),
    swipe1: () => import("@/components/common/swipe1"),
    swipe2: () => import("@/components/common/swipe2"),
    swipe3: () => import("@/components/common/swipe3"),
    indexTitle: () => import("@/components/common/indexTitle"),
    // clickImgChange: () => import("@/components/common/clickImgChange"),
    tab: () => import("@/components/common/tab"),
    tab2: () => import("@/components/common/tab2"),
    find: () => import("@/components/common/find"),
    count: () => import("@/components/form/count"),
    footerForm: () => import("@/components/form/footerForm"),
    indexFoot: () => import("@/components/foot/indexFoot"),
    headpage: () => import("@/components/head/headpage"),
    foot: () => import("@/components/foot/foot"),
    srcoll: () => import("@/components/common/srcoll"),
  },
};
</script>

<style lang="less" scoped>
.menu-img {
  width: 45px;
  height: 45px;
}
.menu-title {
  font-size: 12px;
}
/deep/.van-grid-item__content {
  padding: 5px 8px;
}

.banner {
  margin-top: 50px;
  width: 100%;
  // min-height: 225px;
  min-height: 300px;
}
.menu {
  width: 100%;
  height: 165px;
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}
.menu-item {
  width: 20%;
  margin-right: 2.5%;
  margin-left: 2.5%;
  height: 80px;
}
.menu-item-img {
  width: 80%;
  height: 63px;
  margin-left: auto;
  margin-right: auto;
}
.menu-item-img img {
  width: 100%;
  height: 100%;
}
.menu-item-name {
  width: 100%;
  margin-top: 5px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
}
.class1 {
  width: 100%;
  padding: 10px;
}
.students {
  width: 100%;
  padding: 10px;
}


</style>
